import { render } from "./BlogPostView.vue?vue&type=template&id=a9f87180"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__